import React, { createContext, useContext, useState } from 'react';
import en from './en';
import ar from './ar';
import ru from './ru';
import ka from './ka';
import fr from './fr';
import tr from './tr';
import ja from './ja';
import sw from './sw';
import pt from './pt';
import es from './es';
import ur from './ur';
import zh from './zh';

const allTranslations = { en, ar, tr, ru, ka, fr, ja, sw, pt, es, ur, zh };
const VALID_LANGS = new Set(Object.keys(allTranslations));

export const LANGUAGE_OPTIONS = [
  { code: 'en', name: 'English', dir: 'ltr' },
  { code: 'ar', name: 'العربية', dir: 'rtl' },
  { code: 'tr', name: 'Türkçe', dir: 'ltr' },
  { code: 'ru', name: 'Русский', dir: 'ltr' },
  { code: 'ka', name: 'ქართული', dir: 'ltr' },
  { code: 'fr', name: 'Français', dir: 'ltr' },
  { code: 'ja', name: '日本語', dir: 'ltr' },
  { code: 'sw', name: 'Kiswahili', dir: 'ltr' },
  { code: 'pt', name: 'Português', dir: 'ltr' },
  { code: 'es', name: 'Español', dir: 'ltr' },
  { code: 'ur', name: 'اردو', dir: 'rtl' },
  { code: 'zh', name: '中文', dir: 'ltr' },
];

function getDir(langCode) {
  return LANGUAGE_OPTIONS.find(l => l.code === langCode)?.dir || 'ltr';
}

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    let saved = localStorage.getItem('bigstar_lang') || 'en';
    if (!VALID_LANGS.has(saved)) saved = 'en';
    document.documentElement.dir = getDir(saved);
    document.documentElement.lang = saved;
    return saved;
  });

  function t(key, params) {
    if (!key) return '';
    let text = allTranslations[lang]?.[key] || allTranslations.en[key] || key;
    if (params && typeof params === 'object') {
      Object.entries(params).forEach(([k, v]) => {
        text = text.replace(`{${k}}`, v);
      });
    }
    return text;
  }

  function changeLanguage(newLang) {
    if (!VALID_LANGS.has(newLang)) newLang = 'en';
    localStorage.setItem('bigstar_lang', newLang);
    document.documentElement.dir = getDir(newLang);
    document.documentElement.lang = newLang;
    setLang(newLang);
  }

  const isRTL = getDir(lang) === 'rtl';

  return (
    <LanguageContext.Provider value={{ lang, t, changeLanguage, isRTL }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
